import dotProp from 'dot-prop-immutable';
import * as actionTypes from './actiontypes';
import states from './states';

const kpi_details = (state = states.kpi_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_KPI_STATE: {
      return dotProp.set(state, action.path, action.payload);
    }

    case actionTypes.KPI_FILTER_AND_DATA_LOADED: {
      return {
        ...state,
        filters: action.payload.filters ? action.payload.filters : [...state.filters],
        stats_list: action.payload.kpiStats ? action.payload.kpiStats : [...state.stats_list]
      }
    }

    default:
      return state;
  }
}

export default kpi_details;



// WEBPACK FOOTER //
// ./src/data/redux/kpi_details/reducers.js